<template>
  <div class="sub-header" style="border-right: 1px solid #E9F1F5; margin-right: 0px;">
    <div class="header-item pl-20">
      <Breadcrumb separator-class="el-icon-arrow-right">
        <BreadcrumbItem
          v-if="currentRoute === 'IndentDetails'"
          @click.native="onReadyForBillingClick">
          Ready for billing
        </BreadcrumbItem>
        <BreadcrumbItem
          v-if="currentRoute === 'FreightBillIndentDetails'"
          :to="{ name: 'freightBill' }">
          Freight Bill
        </BreadcrumbItem>
        <BreadcrumbItem
          v-if="currentRoute === 'invoiceDetails'"
          @click.native="onInvoiceClick">
          Invoices
        </BreadcrumbItem>
        <BreadcrumbItem>Indent Details</BreadcrumbItem>
      </Breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentRoute: '',
    };
  },
  created() {
    this.currentRoute = this.$router.history.current.name;
  },
  methods: {
    onReadyForBillingClick() {
      this.$emit('readyForBillingClicked');
    },
    onInvoiceClick() {
      this.$emit('invoiceClicked');
    },
  },
};
</script>

<style lang="scss">
</style>
